<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head" style="justify-content: space-between;">
            <b-button type="is-success" icon-left="check-all" @click="selectAll">Select All</b-button>
            <p class="is-size-5 has-text-black-bis">{{numberOfSelectFile.length}} / {{arrImg.length}}</p>
            <b-button type="is-warning" icon-left="close-outline"  @click="unselectAll" >Unselect All</b-button>
        </header>
        <section class="modal-card-body">

<!--            double-->

            <div class="row columns is-multiline">
                <div class="column is-2"  v-for="dataImg in arrImg " :key="dataImg.id">
                    <div class="card" :style=" dataImg.select ?  `border: 3px solid #cc2f04 `  : `` "    >
                        <header class="card-header" :style=" dataImg.select ?  `  justify-content: space-between; `  : ` background-color: #f0f2f2 ; justify-content: space-between;` "    >
                            <b-checkbox v-model="dataImg.select"  class="card-header-item" style="margin-top: 5px;margin-bottom: 5px; margin-left: 3px;"
                                        type="is-danger">
                            </b-checkbox>
                        </header>
                        <div class="card-image">
                            <figure class="image is-4by3" >
                                <img :src="dataImg.url" alt="Card image" >
                            </figure>
                        </div>
                        <footer class="card-footer"  >


                        </footer>
                    </div>
                </div>







            </div>






        </section>
        <footer class="modal-card-foot"  style="justify-content: space-between;">

            <b-button type="is-danger"
                      icon-left="close"
                      @click="$emit('closeSelectImgForMakePdf')">
                Close
            </b-button>





            <b-field>

                <p class="control">
                    <b-button type="is-success"
                              icon-left="file-pdf-box"
                              :disabled="!numberOfSelectFile.length>0"
                              @click="closeSelectImgForMakePdfWithDataWantTo"
                    >
                        Make Pdf
                    </b-button>
                </p>
                <p class="control">
                    <span class="button is-static">With</span>
                </p>
                <b-select v-model="num_of_col">
                    <option value=3>3</option>
                    <option value=2>2</option>
                    <option value=1>1</option>
                </b-select>
                <p class="control">
                    <span class="button is-static">Column</span>
                </p>
            </b-field>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "SelectImgForMakePdf",
        created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.closeSelectImgForMakePdf()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
        },
        props:{
            arrImg : Array,
        },
        computed:{
            numberOfSelectFile: function () {
                return  this.arrImg.filter(dat=>{
                     return dat.select
                })
            }
        },
        methods:{
            selectAll(){
                this.arrImg.forEach(dat=>{
                    dat.select = true
                })
            },
            unselectAll(){
                this.arrImg.forEach(dat=>{
                    dat.select = false
                })
            },
            closeSelectImgForMakePdf(){
                // console.log('closeSelectImgForMakePdf')
                this.$emit('closeSelectImgForMakePdf')
            },
            closeSelectImgForMakePdfWithDataWantTo(){
                this.$emit('closeSelectImgForMakePdfWithDataWantTo',{"num_of_col" : this.num_of_col , "arrImg" : this.arrImg})
            }
        },
        data(){
            return {
                num_of_col : "3"
                // arrImg : [{"id":1  , "descp": "lorem","select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/179452040286.jpg"},
                //     {"id":2 , "descp": "lorem" ,"select": false,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/373497675695.jpg"},
                //     {"id":3 , "descp": "lorem" ,"select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/386144590903.jpg"},
                //     {"id":4  , "descp": "lorem","select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/568952610950.jpg"},
                //     {"id":5 , "descp": "lorem" ,"select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/606010253106.jpg"}]
            }
        }
    }
</script>

<style scoped>
    img{
        cursor: pointer;
        width:50%;
        height:50%;

        object-fit: contain;

    }

    .card-img{
        border-color: #167df0;
    }
</style>